var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTree1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#006b11",
    d: "M5 0h2M4 1h1m2 0h1M4 2h1m2 0h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#006601",
    d: "M5 1h2M5 2h2M4 3h4M4 4h2m1 1h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#004c0d",
    d: "M3 3h1m4 0h1M3 4h1m4 0h1M2 5h1m6 0h1M2 6h2m5 0h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00560e",
    d: "M6 4h2M3 5h4m1 0h1M4 6h2M5 7h1m1 0h1M6 8h1M6 9h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#004c29",
    d: "M6 6h3M3 7h2m1 0h1m1 0h1M2 8h1m2 0h1m3 0h1M2 9h2m4 0h2m-6 1h5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#003f0a",
    d: "M3 8h2m2 0h2M4 9h2m1 0h1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4c2200",
    d: "M5 11h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree1);
export default __webpack_public_path__ + "static/media/tree1.fcbebac08ef757a778d2d219435647e3.svg";
export { ForwardRef as ReactComponent };